module.exports = __webpack_public_path__ + "static/media/06.1e8358d0.png";